<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Receive Device" active>
            <form-base
              :submit-status="submitStatus"
              action="Update"
              :errors="errors"
              :loading="loading"
              v-on:handleSubmit="handleSubmit"
            >
              <template v-slot:fields>
                <h3 v-if="job.job_shippings && job.job_shippings.length > 0">
                  {{ job.job_shippings[0].courier.name }}
                </h3>

                  
                 <div class="border p-2 my-2">
                  <div class="row">
                    <div class="col-auto">
                      <span class="bg-primary text-white px-3 font-size-26">
                        {{ job.job_number }}</span
                      >
                    </div>
                    <div class="col">
                      <p class="text-muted mt-2 mb-0" v-if="job.manufacture">
                        {{ job.manufacture.description }} -
                        {{ job.device_type.description }}
                        <span v-if="job.device_model">
                          <br />
                          <strong>{{ job.device_model.code }}</strong> -
                          {{ job.imei_in ? job.imei_in : job.serial_in }}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>


                <hr v-if="job.job_shippings && job.job_shippings.length > 0" />

                  <form-group label="IMEI #">
              <input type="text" class="form-control" v-model="job.imei_in" />
              <small v-if="$v.job.imei_in.$error" class="text-danger">
                Please enter IMEI or a SERIAL# (IMEI Should be 15 Characters)
              </small>
           
            </form-group>

            <form-group label="Serial #">
              <input type="text" class="form-control" v-model="job.serial_in" />
              <small v-if="$v.job.serial_in.$error" class="text-danger">
                Please enter IMEI or Serial #
              </small>
            </form-group>

                <form-group label="Device Type" :required="true">
                  <b-skeleton type="input" v-show="loading"></b-skeleton>
                  <v-select
                    label="description"
                    @input="clearModel"
                    :reduce="(deviceType) => deviceType.id"
                    :options="deviceTypes"
                    v-show="!loading"
                    v-model="job.device_type_id"
                  >
                    <template slot="option" slot-scope="dt">
                      <div>{{ dt.code }} - {{ dt.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="dt">
                      {{ dt.description }}
                    </template>
                  </v-select>
                  <small
                    v-if="$v.job.device_type_id.$error"
                    class="text-danger"
                  >
                    Please select type
                  </small>
                </form-group>

                <form-group label="Manufacture" :required="true">
                  <b-skeleton type="input" v-show="loading"></b-skeleton>
                  <v-select
                    label="description"
                    @input="clearModel"
                    :reduce="(manufacture) => manufacture.id"
                    :options="manufactures"
                    v-show="!loading"
                    v-model="job.manufacture_id"
                  >
                    <template slot="option" slot-scope="man">
                      <div>{{ man.code }} - {{ man.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="man">
                      {{ man.description }}
                    </template>
                  </v-select>
                  <small
                    v-if="$v.job.manufacture_id.$error"
                    class="text-danger"
                  >
                    Please select manufacture
                  </small>
                </form-group>

                <form-group
                  :required="true"
                  label="Model"
                  v-if="job.manufacture_id && job.device_type_id"
                >
                  <b-skeleton type="input" v-show="loading"></b-skeleton>
                  <v-select
                    label="description"
                    :reduce="(deviceModel) => deviceModel.id"
                    :options="
                      deviceModels.filter(
                        (m) =>
                          m.manufacture_id == job.manufacture_id &&
                          m.device_type_id == job.device_type_id
                      )
                    "
                    v-show="!loading"
                    v-model="job.device_model_id"
                  >
                    <template slot="option" slot-scope="mod">
                      <div>{{ mod.code }} - {{ mod.description }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="mod">
                      {{ mod.description }}
                    </template>
                  </v-select>
                  <small
                    v-if="$v.job.device_model_id.$error"
                    class="text-danger"
                  >
                    Please select model
                  </small>
                </form-group>

                   <form-group label="Client Ref#">
              <input class="form-control" v-model="job.client_reference" />
            </form-group>
            <form-group label="Manufacture Ref#">
              <input class="form-control" v-model="job.manufacture_reference" />
            </form-group>
            <form-group label="Job Ref#">
              <input class="form-control" v-model="job.job_reference" />
            </form-group>
            <form-group label="Secondary Ref#">
              <input class="form-control" v-model="job.secondary_reference" />
            </form-group>

            <form-group label="POP Supplier" v-if="job.is_in_warranty== 1">
              <input class="form-control" v-model="job.pop_supplier" />
            </form-group>

            <form-group label="POP Date" v-if="job.is_in_warranty == 1">
              <b-form-datepicker
                id="example-datepicker"
                class="form-control"
                v-model="job.pop_date"
              />
            </form-group>


            <form-group label="Policy Number" :required="true" v-if="job.is_insurance_job == 1">
                  <input
                    @blur="$v.job.policy_number.$touch"
                    :class="{ 'is-invalid': $v.job.policy_number.$error }"
                    type="text"
                    class="form-control"
                    v-model="job.policy_number"
                  />
                </form-group>

                <form-group label="SPM Number" v-if="job.is_insurance_job == 1">
                  <input
                    type="text"
                    class="form-control"
                    v-model="job.spm_number"
                  />
                </form-group>

                <form-group label="Claim Number" :required="true" v-if="job.is_insurance_job == 1">
                  <input
                    type="text"
                    @blur="$v.job.claim_number.$touch"
                    :class="{ 'is-invalid': $v.job.claim_number.$error }"
                    class="form-control"
                    v-model="job.claim_number"
                  />
                </form-group>

               
              </template>
            </form-base>
          </b-tab>

          <b-tab title="Client" v-if="job.client_id">
            <client :id="job.client_id" class="mt-3"></client>
          </b-tab>

          <b-tab v-if="job.partner_id" title="Partner">
            <partner :id="job.partner_id" class="mt-3"></partner>
          </b-tab>

          <b-tab title="Job">
            <job-minimal :id="id"></job-minimal>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobRepo from "@/api/repos/jobRepo";
import { required,requiredIf,maxLength,minLength } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import partner from "@/views/modules/partners/show";
import client from "@/views/modules/clients/show";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";

export default {
  components: {
    formBase,
    formGroup,
    partner,
    client,
    jobMinimal,
  },

  props: ["id"],

  mounted() {
    this.getCreatedData(this.id);
  },

  data() {
    return {
      manufactures: [],
      deviceTypes: [],
      deviceModels: [],
      deviceConditions: [],
      deviceAccessories: [],
      shipping: {},
      job: {},
      loading: false,
      errors: null,
      submitStatus: null,
     
    };
  },

  validations: {
    job: {
      imei_in: {
        required: requiredIf(function (job) {
          return job.serial_in == null;
        }),
        minLength:minLength(15),
        maxLength:maxLength(15)
      },
      serial_in: {
        required: requiredIf(function (job) {
          return job.imei_in == null;
        }),
      },
      device_type_id: {
        required,
      },
      manufacture_id: {
        required,
      },
      device_model_id: {
        required,
      },
       claim_number: {
        required: requiredIf(function () {
          return (this.job.is_insurance_job == 1);
        }),
      },
      policy_number: {
        required: requiredIf(function () {
          return (this.job.is_insurance_job == 1);
        }),
      },
    },
  },

  methods: {
    async getCreatedData(id) {
      try {
        this.loading = true;
        let { data } = await jobRepo.detailsUpdateCreate(id);
        
        this.job = data.job;
        this.deviceModels = data.device_models;
        this.manufactures = data.manufactures;
        this.deviceTypes = data.device_types;
       
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    clearModel() {
      if (this.job.device_model_id != null) {
        this.job.device_model_id = null;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
        
          await jobRepo.detailsUpdateStore(this.job);
          this.$emit("updateCreated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>

